'use client';

import RouteTabs from '@pc/components/molecules/tab/RouteTabs';
import RouteTabsItem from '@pc/components/molecules/tab/RouteTabsItem';

function PickRouteTabs() {
  return (
    <section>
      <RouteTabs className='mb-10' contentClassName='flex justify-start w-full px-4'>
        <RouteTabsItem className='ml-0 text-[18px]' path='/pick/fan'>
          FAN
        </RouteTabsItem>
        <RouteTabsItem className='ml-0 text-[18px]' path='/pick/gift'>
          GIFT
        </RouteTabsItem>
        <RouteTabsItem className='ml-0 text-[18px]' path='/pick/watch'>
          WATCH
        </RouteTabsItem>
        <RouteTabsItem className='ml-0 text-[18px]' path='/pick/bookmark'>
          BOOKMARK
        </RouteTabsItem>
      </RouteTabs>
    </section>
  );
}

export default PickRouteTabs;
